/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxtBuildsV1RepoEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXT_BUILDS_V1_REPO_EVENT_ENTITY_NAME = 'ixt.builds.v1.RepoEvent';
export const ixtBuildsV1RepoEventEntity = new schema.Entity<IxtBuildsV1RepoEvent>(IXT_BUILDS_V1_REPO_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxtBuildsV1RepoEvent) => `${entity.metadata?.eventId}` });

